import { Address } from '../models/address';

/**
 * Map to address model.
 * @param {object} dto Dto.
 * @returns {Address}
 */
function fromDto(dto) {
  return new Address({
    id: dto.id,
    street: dto.street,
    street2: dto.street2,
    city: dto.city,
    stateCode: dto.state_code,
    zip: dto.zip,
    region: dto.region,
  });
}

export const addressMapper = {
  fromDto,
};
